import { syncUserData, User, UserData } from '@msdk/definitions'
import { atom } from 'recoil'

export const $auth = atom<User | null>({
  default: null,
  key: 'AuthUser',
  effects: [
    ({ onSet }) => {
      onSet((auth) => {
        syncUserData(auth?.profile as UserData)
      })
    },
  ],
})

// Commenting following JWT login due to deprecation in favor of Ref token
// export const $convertedToken = atom<string | null>({
//   default: null,
//   key: 'ConvertedToken',
// })
